// extracted by mini-css-extract-plugin
export default {"interviewNav":"Kih3rDl8WnND4ORXNxh1"};